import { Divider } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';

export const ReferrerDetails = ({ applicantData }) => {
  const { t } = useTranslation();
  return (
    <div className="applicantDetailsCard">
      <h3 className="titlePersonalHD marginBottom10">{applicantData?.primarySource || "N/A"}</h3>
      <Divider sx={{ border: '1px dashed #D6D6D6', mb: 2, mt: 2 }} />
      <h3 className="titlePersonalHD marginBottom10">Referrer Details</h3>
      <div className="personalInfo width50">

        {applicantData?.sourceDetails?.name ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.thankYou.customerName")}</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.name || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.projectName ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.referrerDetails.project")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.projectName || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.contactNumber ? (
          <div className="personalInfoRow">
            <p className="label200">{t("commonLabels.contactNumber")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData && applicantData?.sourceDetails?.contactNumber
                ? `${applicantData?.sourceDetails?.countryCode} ${applicantData?.sourceDetails?.contactNumber}`
                : "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.unit ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.referrerDetails.unit")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.unit || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.email ? (
          <div className="personalInfoRow">
            <p className="label200">{t("commonLabels.email")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.email || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.referredBy ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.referrerDetails.referredBy")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.referredBy || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.employeeName ? (
          <div className="personalInfoRow">
            <p className="label180">{t("voucherPreview.referrerDetails.empName")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.employeeName || "N/A"}
            </span>
          </div>
        ) : null}


        {applicantData?.sourceDetails?.employeeId ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.referrerDetails.empId")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.employeeId || "N/A"}
            </span>
          </div>
        ) : null}

        {applicantData?.sourceDetails?.activityName ? (
          <div className="personalInfoRow">
            <p className="label200">{t("voucherPreview.referrerDetails.activityName")}:</p>
            <span style={{
              display: 'flex',
              wordBreak: 'break-word',
              whiteSpace: 'normal',
              maxWidth: '100%',
            }}>
              {applicantData?.sourceDetails?.activityName || "N/A"}
            </span>
          </div>
        ) : null}

      </div>

    </div>
  )
}
